import { useWorkflowEditorContext } from "components/WorkflowEditor/WorkflowEditorProvider/WorkflowEditorProvider";
import { FieldTableKey } from "pages/gdt/modals/fields/FieldTableKey";
import { FieldTableName } from "pages/gdt/modals/fields/FieldTableName";

export const WorkflowEditorPageNameAndKey = () => {
  const handleChangeTableName = useWorkflowEditorContext(
    (s) => (name: string) => {
      s.setTableProps("name", name);
    },
  );
  const handleChangeTableKey = useWorkflowEditorContext(
    (s) => (key: string) => {
      s.setTableProps("key", key);
    },
  );
  const tableName = useWorkflowEditorContext((s) => s.tableProps.name);
  const tableKey = useWorkflowEditorContext((s) => s.tableProps.key);

  return (
    <>
      <FieldTableName
        autoFocus
        onChange={({ value }) => handleChangeTableName(value)}
        value={tableName}
      />

      <FieldTableKey
        autoGenerate
        onChange={({ value }) => handleChangeTableKey(value)}
        onAutoGenerate={handleChangeTableKey}
        tableName={tableName}
        value={tableKey}
      />
    </>
  );
};
